import { render, staticRenderFns } from "./Modular.vue?vue&type=template&id=1ce18704&"
import script from "./Modular.vue?vue&type=script&lang=js&"
export * from "./Modular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports